import { useEffect, useMemo, useRef } from 'react';

import {
  buildSegmentIdentity,
  isAutomationCustomAiPath,
} from '~/common/analytics/segmentIdentity';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { useRouting } from '~/routing/useRouting';

import { trackPage } from '../SegmentAnalytics';

export const useTrackPage = () => {
  const { location } = useRouting();
  const user = useCurrentUser();
  const userId = user?.id;
  const clientId = user?.client;
  const clientName = user?.client_name;

  const identity = useMemo(
    () => buildSegmentIdentity(userId, clientId, clientName),
    [userId, clientId, clientName],
  );

  const trackedNonAutomationLocationRef = useRef<unknown>(null);

  useEffect(() => {
    const pathname = location.pathname ?? '';

    if (!isAutomationCustomAiPath(pathname)) {
      if (trackedNonAutomationLocationRef.current === location) return;
      trackedNonAutomationLocationRef.current = location;
      trackPage();
      return;
    }

    trackedNonAutomationLocationRef.current = null;
    trackPage({
      ...identity,
      path: pathname,
      url:
        globalThis.location === undefined ? pathname : globalThis.location.href,
      product_area: 'custom_ai',
    });
  }, [location, identity]);
};
